import React, { Component, useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

import './css/styles.scss'

import OrdersList from './list/List.jsx'
import OrdersShow from './order/Order.jsx'

const containerList = document.getElementById('root-manager-orders-list'),
containerOrder = document.getElementById('root-manager-orders-show')

if (containerList) ReactDOM.render(<OrdersList />, containerList)
if (containerOrder) ReactDOM.render(<OrdersShow />, containerOrder)